export default __webpack_public_path__ + "static/media/view-grid.f9adee1a.svg";